import { render, staticRenderFns } from "./ModuleSchemeSlotPicker.vue?vue&type=template&id=639b80d4&scoped=true"
import script from "./ModuleSchemeSlotPicker.vue?vue&type=script&lang=js"
export * from "./ModuleSchemeSlotPicker.vue?vue&type=script&lang=js"
import style0 from "./ModuleSchemeSlotPicker.vue?vue&type=style&index=0&id=639b80d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b80d4",
  null
  
)

export default component.exports